export default __webpack_public_path__ + "media/zurb/img/development-process/qa_sheet-aeb0b68d85090cb32baba97628ab090e.png";